/**
 * The service identity for the bridge command registry.
 * @experimental
 * @internal
 */
export const BridgeCommandRegistryIdentity = Symbol("BridgeCommandRegistry");
//# sourceMappingURL=bridgeCommandRegistry.js.map